import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { gamesAPI } from '../services/api';
import { useProfile } from '../context/ProfileContext';

const GAME_ROUTES = {
  'memory-game': '/games/memory',
  'guess-the-picture': '/games/guess',
  'maze-escape': '/games/maze',
  'word-scramble': '/games/word',
  'color-match': '/games/color'
};

export default function GamesScreen() {
  const navigate = useNavigate();
  const { profile } = useProfile();
  const [games, setGames] = useState([]);
  const [progress, setProgress] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const [gamesData, progressData] = await Promise.all([
        gamesAPI.getAll(),
        profile ? gamesAPI.getProgress(profile.id) : []
      ]);
      setGames(gamesData);
      setProgress(progressData);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const getGameProgress = (gameId) => {
    return progress.find(p => p.game_name === gameId);
  };

  const handlePlay = (game) => {
    const route = GAME_ROUTES[game.id] || '/games/memory';
    navigate(route);
  };

  return (
    <div className="screen">
      <div className="screen-header" style={{ background: 'linear-gradient(135deg, #FF6B6B, #FF8E53)', paddingBottom: 20 }}>
        <button className="btn-back" onClick={() => navigate('/')} style={{ background: 'rgba(255,255,255,0.3)', color: 'white' }}>←</button>
        <div>
          <h1 style={{ fontFamily: 'var(--font-title)', color: 'white', fontSize: '1.6rem' }}>🎮 Games</h1>
          <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: '0.85rem' }}>Play & earn stars!</p>
        </div>
      </div>

      <div className="screen-body" style={{ paddingTop: 20 }}>
        {loading ? (
          <div style={{ textAlign: 'center', padding: 40 }}>
            <div className="spinner" style={{ margin: '0 auto' }}></div>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            {games.map(game => {
              const prog = getGameProgress(game.id);
              return (
                <div
                  key={game.id}
                  className="card card-clickable"
                  onClick={() => handlePlay(game)}
                  style={{ display: 'flex', alignItems: 'center', gap: 16, padding: 16 }}
                >
                  <div style={{
                    width: 64, height: 64, borderRadius: 16,
                    background: game.color + '22', fontSize: '2rem',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    flexShrink: 0
                  }}>
                    {game.icon}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 800, fontSize: '1rem', marginBottom: 2 }}>{game.name}</div>
                    <div style={{ color: 'var(--gray)', fontSize: '0.8rem', marginBottom: 6 }}>{game.description}</div>
                    <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                      <span style={{
                        background: game.color + '22', color: game.color,
                        padding: '2px 10px', borderRadius: 10, fontSize: '0.75rem', fontWeight: 700
                      }}>
                        {game.difficulty}
                      </span>
                      {prog && (
                        <span style={{ color: 'var(--gray)', fontSize: '0.75rem' }}>
                          🏆 Best: {prog.best_score} | Played: {prog.plays_count}x
                        </span>
                      )}
                    </div>
                  </div>
                  <div style={{ color: 'var(--gray)', fontSize: '1.2rem' }}>▶</div>
                </div>
              );
            })}
          </div>
        )}

        <div className="card" style={{ background: '#FFF9E6', border: '2px solid var(--yellow)', marginTop: 8 }}>
          <div style={{ fontWeight: 800, marginBottom: 4 }}>⭐ Points per game</div>
          <div style={{ color: 'var(--gray)', fontSize: '0.85rem' }}>Play any game and earn <strong>+10 points!</strong></div>
        </div>
      </div>
    </div>
  );
}
